import React, { useEffect, useState } from "react";
import axios from "axios";

const Contacts = () => {
    const [socials, setSocials] = useState(null);

    useEffect(() => {
        axios.get("https://kyrgyz-adventure-travel.com/api/v1/tours/contacts")
            .then(response => {
                if (response.data.results.length > 0) {
                    setSocials(response.data.results[0]);
                }
            })
            .catch(error => console.error("Error loading data: ", error));
    }, []);

    if (!socials) return null;

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-3">
                <a
                    href={socials.whatsapp}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="font-unbounded text-2xl text-white hover:text-gold transition-colors duration-200"
                >
                    +{socials.whatsapp.match(/(\d+)$/)[1]}
                </a>
                <a
                    href={`https://mail.google.com/mail/?view=cm&fs=1&to=${socials.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-manrope text-white/60 hover:text-gold transition-colors duration-200"
                >
                    {socials.email}
                </a>
            </div>
            <a
                href={socials.address}
                rel="noopener noreferrer"
                target="_blank"
                className="flex items-center gap-3 font-manrope text-white/60 hover:text-gold transition-colors duration-200"
            >
                <svg width="14" height="20" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 7.54932C14 6.63006 13.8189 5.71981 13.4672 4.87053C13.1154 4.02125 12.5998 3.24958 11.9497 2.59957C11.2997 1.94956 10.5281 1.43394 9.67878 1.08216C8.8295 0.730377 7.91925 0.549316 7 0.549316C6.08075 0.549316 5.17049 0.730377 4.32122 1.08216C3.47194 1.43394 2.70026 1.94956 2.05025 2.59957C1.40024 3.24958 0.884626 4.02125 0.532843 4.87053C0.18106 5.71981 -1.36979e-08 6.63006 0 7.54932C0 8.93632 0.41 10.2263 1.105 11.3143H1.097C3.457 15.0093 7 20.5493 7 20.5493L12.903 11.3143H12.896C13.6164 10.1907 13.9995 8.88406 14 7.54932ZM7 10.5493C6.20435 10.5493 5.44129 10.2332 4.87868 9.67064C4.31607 9.10803 4 8.34497 4 7.54932C4 6.75367 4.31607 5.99061 4.87868 5.428C5.44129 4.86539 6.20435 4.54932 7 4.54932C7.79565 4.54932 8.55871 4.86539 9.12132 5.428C9.68393 5.99061 10 6.75367 10 7.54932C10 8.34497 9.68393 9.10803 9.12132 9.67064C8.55871 10.2332 7.79565 10.5493 7 10.5493Z" fill="currentColor"/>
                </svg>
                Our address
            </a>
        </div>
    );
};

export default Contacts;
